import avatar1 from '../assets/images/avatars/1.png';
import avatar2 from '../assets/images/avatars/2.png';
import avatar3 from '../assets/images/avatars/3.png';
import avatar4 from '../assets/images/avatars/4.png';
import avatar5 from '../assets/images/avatars/5.png';
import {useState} from "react";

const avatars = [
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    avatar5,
];

const useRandomAvatar = () => {
    const [avatar] = useState(avatars[Math.floor(Math.random() * avatars.length)]);
    return {avatar};
}

export default useRandomAvatar;
